function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { DATE_MILLISECONDS, sortDate, weekOfYear } from '@bydesign-ui/utils';
import { PanelType } from './BasePanel';
import { RangeDate } from './RangeDate';
export var CompareRangeDate = function (_Emitter) {
  _inherits(CompareRangeDate, _Emitter);

  var _super = _createSuper(CompareRangeDate);

  function CompareRangeDate(panelType, rangeDateParts) {
    var _this;

    _classCallCheck(this, CompareRangeDate);

    _this = _super.call(this);
    _this.startDay = 0;
    _this.offsetDate = null;
    _this.isCompare = false;

    _this.calculateOffsetDate = function (_, source) {
      var _a;

      var _sortDate = sortDate(source),
          _sortDate2 = _slicedToArray(_sortDate, 2),
          start = _sortDate2[0],
          end = _sortDate2[1];

      _this.offsetDate = _this.getOffsetDate(start, end);
      var targetOffset = (_a = _this.targetOffset) !== null && _a !== void 0 ? _a : source.length && _this.offsetDate;

      _this.targetRangeDate.updateOptions({
        offset: targetOffset,
        startDay: _this.startDay
      });

      _this.onRangePanelUpdate && _this.onRangePanelUpdate(_this.sourceRangeDate, source);

      _this.emit('offset-update', _this.offsetDate);
    };

    _this.sourceValueUpdate = function (value) {
      _this.emit('value-change', {
        source: value,
        isCompare: _this.isCompare,
        target: []
      });
    };

    _this.sourceSetPanelDate = function (params) {
      _this.onSetPanelDate && _this.onSetPanelDate(_this.sourceRangeDate, params);
    };

    _this.targetValueUpdate = function (value) {
      if (!_this.isCompare) {
        throw new Error("Cant change target value when isCompare is ".concat(_this.isCompare));
      }

      _this.emit('value-change', {
        source: _this.sourceRangeDate.getValue(),
        isCompare: _this.isCompare,
        target: value
      });
    };

    _this.targetRangePanelUpdate = function (_, value) {
      _this.onRangePanelUpdate && _this.onRangePanelUpdate(_this.targetRangeDate, value);
    };

    _this.targetSetPanelDate = function (params) {
      _this.onSetPanelDate && _this.onSetPanelDate(_this.targetRangeDate, params);
    };

    _this.sourceRangeDate = new RangeDate(panelType);
    _this.targetRangeDate = new RangeDate(panelType);
    _this.panelType = panelType;
    rangeDateParts.forEach(function (part) {
      _this.sourceRangeDate.createPanel(panelType, part);

      _this.targetRangeDate.createPanel(panelType, part);
    });

    _this.init();

    return _this;
  }

  _createClass(CompareRangeDate, [{
    key: "updateValue",
    value: function updateValue(value) {
      var source = value.source,
          isCompare = value.isCompare,
          target = value.target;
      this.isCompare = isCompare;
      this.sourceRangeDate.updateValue(source);
      this.targetRangeDate.updateValue(target);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var sourceOffset = options.sourceOffset,
          targetOffset = options.targetOffset,
          startDay = options.startDay,
          extra = _objectWithoutProperties(options, ["sourceOffset", "targetOffset", "startDay"]);

      this.startDay = startDay || 0;
      this.targetOffset = targetOffset;
      this.sourceRangeDate.updateOptions(_objectSpread(_objectSpread({}, extra), {}, {
        startDay: startDay,
        offset: sourceOffset
      }));
      this.targetRangeDate.updateOptions(_objectSpread(_objectSpread({}, extra), {}, {
        startDay: startDay,
        offset: targetOffset
      }));
    }
  }, {
    key: "setSetPanelDate",
    value: function setSetPanelDate(updater) {
      this.onSetPanelDate = updater;
    }
  }, {
    key: "setRangePanelUpdate",
    value: function setRangePanelUpdate(updater) {
      this.onRangePanelUpdate = updater;
    }
  }, {
    key: "getOffset",
    value: function getOffset() {
      return this.offsetDate;
    }
  }, {
    key: "getIsCompare",
    value: function getIsCompare() {
      return this.isCompare;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.sourceRangeDate.removeListener('value-change', this.sourceValueUpdate);
      this.targetRangeDate.removeListener('value-change', this.targetValueUpdate);
      this.sourceRangeDate.removeListener('set-panel-date', this.sourceSetPanelDate);
      this.targetRangeDate.removeListener('set-panel-date', this.targetSetPanelDate);
    }
  }, {
    key: "init",
    value: function init() {
      this.sourceRangeDate.setRangePanelUpdate(this.calculateOffsetDate);
      this.targetRangeDate.setRangePanelUpdate(this.targetRangePanelUpdate);
      this.sourceRangeDate.addListener('value-change', this.sourceValueUpdate);
      this.targetRangeDate.addListener('value-change', this.targetValueUpdate);
      this.sourceRangeDate.addListener('set-panel-date', this.sourceSetPanelDate);
      this.targetRangeDate.addListener('set-panel-date', this.targetSetPanelDate);
    }
  }, {
    key: "getOffsetDate",
    value: function getOffsetDate(start, end) {
      if (this.panelType === PanelType.YEAR) {
        return end.getFullYear() - start.getFullYear() + 1;
      }

      if (this.panelType === PanelType.MONTH) {
        return end.getFullYear() * 12 + end.getMonth() - start.getFullYear() * 12 - start.getMonth() + 1;
      }

      if (this.panelType === PanelType.WEEK) {
        return weekOfYear(end, this.startDay, 1970) - weekOfYear(start, this.startDay, 1970) + 1;
      }

      return ((end.getTime() - start.getTime()) / DATE_MILLISECONDS | 0) + 1;
    }
  }]);

  return CompareRangeDate;
}(Emitter);